import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ModelResourceAbstract } from '../../shared/resources/abstract/model.resource.abstract';
import { DialPlanExceptionGroup } from '../../shared/models/generated/ziroModels';

@Injectable({ providedIn: 'root' })
export class DialPlanExceptionResource extends ModelResourceAbstract<DialPlanExceptionGroup> {
  protected _baseUrl = '/services/cisco/admin/dial-plan-exception-groups/groups';

  getAll: () => Observable<DialPlanExceptionGroup[]>;
  get: (id: number) => Observable<DialPlanExceptionGroup>;
  post: (dnExceptionGroup: DialPlanExceptionGroup) => Observable<DialPlanExceptionGroup>;
  put: (id: number, dnExceptionGroup: DialPlanExceptionGroup) => Observable<DialPlanExceptionGroup>;
  delete: (id: string) => Observable<void>;
}
